import { checkDepartmentFiltersHaveBeenApplied } from '../utils/checkDepartmentFiltersHaveBeenApplied'
import { updateDepartmentCounts } from './helpers'
import type { SearchStoreState } from './types'

export const getNextState = (
  currentState: SearchStoreState,
  newState: Partial<SearchStoreState> | undefined,
) => {
  const hasSearchTermChanged =
    newState?.searchContext?.searchTerm !==
    currentState.searchContext.searchTerm

  const haveFiltersBeenApplied = checkDepartmentFiltersHaveBeenApplied(
    currentState.departmentFilters,
  )

  const previousDepartment = currentState.searchContext.departments[0]
  const newDepartment = newState?.searchContext?.departments[0]

  let nextState = {
    ...currentState,
    ...newState,
    departmentFilters: hasSearchTermChanged
      ? {}
      : currentState.departmentFilters,
  }

  if (
    newState &&
    newDepartment !== previousDepartment &&
    haveFiltersBeenApplied
  ) {
    nextState = {
      ...nextState,
      searchContext: {
        ...(newState.searchContext ||
          /* istanbul ignore next */ currentState.searchContext),
        departmentCounts: updateDepartmentCounts({
          currentState,
          newState,
          newDepartment,
        }),
      },
    }
  }

  return nextState
}
